import { SearchData } from 'types/searchData'
import sendData from '../../utils/sendData'
import transformFlightDetails from '../../utils/transformFlightDetails'

export const success = (searchData: SearchData) => {
  sendData('serp_avia.page_load.success', transformFlightDetails(searchData))
}
